/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './billing.component.less.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../core/stripe/stripe.component.ngfactory';
import * as i3 from '../../../../app/core/stripe/stripe.component';
import * as i4 from '@angular/forms';
import * as i5 from 'ngx-stripe';
import * as i6 from '@angular/router';
import * as i7 from '../../../../app/core/billing.service';
import * as i8 from '../../../../app/core/get.service';
import * as i9 from 'angular2-notifications/src/simple-notifications/services/notifications.service';
import * as i10 from '@ngx-translate/core/src/translate.service';
import * as i11 from '@angular/common';
import * as i12 from '../../../../app/custom/billing/billing.component';
const styles_BillingComponent:any[] = [i0.styles];
export const RenderType_BillingComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_BillingComponent,data:{}});
function View_BillingComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'modal-component']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),4,'div',[['class','card']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n    '])),(_l()(),i1.ɵeld(4,0,(null as any),(null as any),1,'app-stripe',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_StripeComponent_0,
      i2.RenderType_StripeComponent)),i1.ɵdid(5,114688,(null as any),0,i3.StripeComponent,
      [i4.FormBuilder,i5.StripeService,i6.ActivatedRoute,i7.BillingService,i8.GetService,
          i9.NotificationsService,i10.TranslateService],{hideBilling:[0,'hideBilling']},
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,
      (null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.hideBilling;
    _ck(_v,5,0,currVal_0);
  },(null as any));
}
export function View_BillingComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_BillingComponent_1)),i1.ɵdid(1,16384,(null as any),0,i11.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i12.BillingComponent = _v.component;
    const currVal_0:any = _co.getShow();
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_BillingComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-billing',
      ([] as any[]),(null as any),(null as any),(null as any),View_BillingComponent_0,
      RenderType_BillingComponent)),i1.ɵdid(1,49152,(null as any),0,i12.BillingComponent,
      [i1.NgZone,i1.ApplicationRef,i7.BillingService],(null as any),(null as any))],
      (null as any),(null as any));
}
export const BillingComponentNgFactory:i1.ComponentFactory<i12.BillingComponent> = i1.ɵccf('app-billing',
    i12.BillingComponent,View_BillingComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY3VzdG9tL2JpbGxpbmcvYmlsbGluZy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS92c3RzL3dvcmsvMS9zL2Vtci13ZWJhcHAvc3JjL2FwcC9jdXN0b20vYmlsbGluZy9iaWxsaW5nLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY3VzdG9tL2JpbGxpbmcvYmlsbGluZy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY3VzdG9tL2JpbGxpbmcvYmlsbGluZy5jb21wb25lbnQudHMuQmlsbGluZ0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgKm5nSWY9XCJnZXRTaG93KClcIiBjbGFzcz1cIm1vZGFsLWNvbXBvbmVudFwiPlxuICA8ZGl2IGNsYXNzPVwiY2FyZFwiPlxuICAgIDxhcHAtc3RyaXBlIFtoaWRlQmlsbGluZ109XCJoaWRlQmlsbGluZ1wiPjwvYXBwLXN0cmlwZT5cbiAgPC9kaXY+XG48L2Rpdj5cbiIsIjxhcHAtYmlsbGluZz48L2FwcC1iaWxsaW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFBLGdCQUErQyw0Q0FDN0M7TUFBQTtNQUFBLDRDQUFrQjtNQUFBLGFBQ2hCO01BQUE7bUNBQUEsVUFBQTtNQUFBO3NEQUFBO01BQUEsZUFBcUQsNENBQ2pEO01BQUE7O0lBRFE7SUFBWixXQUFZLFNBQVo7Ozs7b0JBRko7TUFBQSxpQ0FBQTtvQkFBQSxtQ0FJTTtNQUFBOztJQUpEO0lBQUwsV0FBSyxTQUFMOzs7O29CQ0FBO01BQUE7aUNBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/custom/billing/billing.component.ngfactory.ts